import axios from 'axios';
import Env from '~/env';

let appServer: string | null = null;

const apiHybris = axios.create({
  baseURL: `https://${Env.API_HOST}/marisaomniwebservices/v2/marisa/`,
});

apiHybris.interceptors.request.use(async (config) => {
  if (config) {
    if (appServer) {
      config.headers.Cookie = `LBAPI=${appServer}`;
    }

    if (config.url) {
      //TODO Get user const user: UserType | null = await getUserHybris();
      const user: any | null = null;

      if (
        config.url.includes('{{username}}') ||
        config.url.includes('/current/')
      ) {
        if (user) {
          config.url = config.url.replace('{{username}}', 'current');
          config.headers.Authorization = `Bearer ${user.token}`;
        } else {
          config.url = config.url.replace('{{username}}', 'anonymous');
        }
      }
    }
  }

  return config;
});

// apiHybris.interceptors.response.use(
//   (response) => response,
//   (err) => {
//     if (err.response) {
//       if (err.response.status === 401) {
//         // TODO navega para login
//       }
//     }
//     return Promise.reject(err);
//   }
// );

export default apiHybris;
